import React from "react";
import styled, { css } from "styled-components";
import { format, parseISO } from "date-fns";
import { da } from "date-fns/locale";
import * as _ from "lodash";

// Const
const ACT_TRAINING = "NCDFOapeUK5GsU6PHTBo";
const ACT_INSTRUCTOR = "qw0N72HFzjXJeNQAmCk2";

const ToolTipWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 150px;
  width: 160px;
  min-height: 40px;
  font-size: 16px;


  /* opacity: 1;
  background: blue;
  padding: 0;
  margin: 0; */
`;

const ActivityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;
const ActivityItem = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  margin-top: 5px;
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 6px;
  border: 2px solid #000;

  ${({ actTypeId }) =>
    actTypeId == ACT_INSTRUCTOR &&
    css`
      background: #ef006e;
    `}
  ${({ actTypeId }) =>
    actTypeId == ACT_TRAINING &&
    css`
      background: #003271;
    `}


  .content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;

    .instructor {
      flex: 1 1 auto;
      color: #dde;
      font-size: 14px;
    }
  }
`;

// const ActTypeBlock = styled.div`

// width: 18px;
// height: 18px;
// border: 1px solid white;
// flex: 0 0 20px;
// margin-left: 5px;
// margin-right: 10px;

//  ${({ actTypeId }) =>
//    actTypeId == ACT_INSTRUCTOR &&
//    css`
//      background: #ef006e;
//    `}
//  ${({ actTypeId }) =>
//    actTypeId == ACT_TRAINING &&
//    css`
//      background: #003271;
//    `}
// }
// `;

export default function CustomTooltip({
  getStyle,
  primaryAxis,
  datum,
  activities
}) {
  console.log("datum >> ", datum);
  console.log("primaryAxis >> ", primaryAxis);
  console.log("activities >> ", activities);
  console.log(
    "Months is ",
    datum && datum.originalDatum && datum.originalDatum[2]
  );

  const currentMonth = datum && datum.originalDatum && datum.originalDatum[2];

  const activitiesForCurrentMonth = _.sortBy(activities, "Date")
    .filter(act => format(parseISO(act.Date), "M") == currentMonth)
    .map((act, idx) => {
      return (
        <ActivityItem key={idx} actTypeId={act.ActivityTypeId}>
          {/* <ActTypeBlock actTypeId={act.ActivityTypeId} /> */}
          <div className="content">
            <div>
              {format(parseISO(act.Date), "eee dd. MMM yyyy", { locale: da })}
            </div>
            <div className="instructor">{act.Instructor}</div>
          </div>
        </ActivityItem>
      );
    });

  return (
    <ToolTipWrapper>
      <ActivityWrapper>{activitiesForCurrentMonth}</ActivityWrapper>
    </ToolTipWrapper>
  );
}
